import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LandingpageComponent } from './landingpage.component';
import { ReactiveFormsModule } from '@angular/forms';
import { OuterHeaderNavigationModule } from '../shared/outer-header-navigation/outer-header-navigation.module';

const routes: Routes = [
  { path: '', component: LandingpageComponent },
  { path: '**', redirectTo: '/login', pathMatch: 'full' }
]

@NgModule({
  declarations: [LandingpageComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    OuterHeaderNavigationModule,
    ReactiveFormsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LandingPageModule { }
